import { isEmpty } from "lodash";

export class NumberFormat {
  static simNumber(phone: string): string {
    if (!isEmpty(phone) && phone != null) {
      return phone.replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3");
    } else {
      return "";
    }
  }

  static generateCaptcha = (length: number): string =>
      Array.from({ length }, () => {
        const characters =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        return characters.charAt(Math.floor(Math.random() * characters.length));
      }).join("");

  static currencyFormat(value: number | string) {
    return `${new Intl.NumberFormat("de-DE", {
      style: "decimal",
    }).format((value as number) || parseFloat(value as string))} ${
        this.CurrentCurrency
    }`;
  }

  static toRawNumber(value: number | string) {
    return new Intl.NumberFormat("de-DE", {
      style: "decimal",
    }).format(
      (value as number) || parseFloat((value as string).replace(/[^\d]/g, ""))
    );
  }

  static CurrentCurrency = "VND";
}
